import { RESET_DATASET } from 'store';

import { SET_SECONDARY_PARAMETER } from './types';
import { RESET_RANDOMIZATION_HYPOTHESIS_TESTING } from '../types';

export default (state = null, action) => {
  switch (action.type) {
    case SET_SECONDARY_PARAMETER:
      return action.secondaryParameter;
    case RESET_DATASET:
    case RESET_RANDOMIZATION_HYPOTHESIS_TESTING:
      return null;
    default:
      return state;
  }
};
